module.exports = __webpack_public_path__ + "img/private-green.ca686b60.png";